/**
 * Get the first error message from an errors object.
 *
 * @param {Object} errors - The errors object, typically received in a validation response.
 * @returns {string | null} - The first error message, or null if no errors are present.
 */
export const getFirstErrorMessage = errors => {
  if (errors && Object.keys(errors).length > 0) {
    const firstErrorKey = Object.keys(errors)[0]
    const firstErrorMessage = errors[firstErrorKey][0]
    return firstErrorMessage
  }
  return 'Error desconocido'
}

/**
 * Validates email format. Returns an array of error messages (empty if valid).
 * Catches common mistakes: missing @, missing/invalid domain (.com, .ar, etc.).
 *
 * @param value - The email string to validate (can be undefined/null).
 * @returns Array of user-facing error messages.
 */
export function getEmailValidationErrors(value: string | undefined | null): string[] {
  const trimmed = typeof value === 'string' ? value.trim() : ''
  if (!trimmed) {
    return ['El email es obligatorio']
  }
  if (!trimmed.includes('@')) {
    return ['El email debe contener @ (ej: usuario@dominio.com)']
  }
  const atCount = (trimmed.match(/@/g) || []).length
  if (atCount > 1) {
    return ['El email solo debe contener un @']
  }
  const [local, domain] = trimmed.split('@')
  if (!local || !local.length) {
    return ['Falta la parte antes del @ (ej: usuario@dominio.com)']
  }
  if (!domain || !domain.length) {
    return ['Falta el dominio después del @ (ej: usuario@dominio.com)']
  }
  if (!domain.includes('.')) {
    return ['El dominio debe contener una extensión (ej: .com, .ar)']
  }
  const tld = domain.split('.').pop() || ''
  if (tld.length < 2) {
    return ['La extensión del dominio debe tener al menos 2 letras (.com, .ar, etc.)']
  }
  // Optional: basic format check (no spaces, reasonable chars)
  if (/\s/.test(trimmed)) {
    return ['El email no debe contener espacios']
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
  if (!emailRegex.test(trimmed)) {
    return ['Formato de email inválido (ej: nombre@dominio.com)']
  }
  return []
}
